import { apiClient, ApiResponse } from './api'

export interface Tenant {
  _id: string
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  deletedAt: string | null
  deletedBy: string | null
  name: string
  status: 'PENDING' | 'ACTIVE' | 'INACTIVE' | 'SUSPENDED'
  __v: number
}

export interface TenantsResponse {
  success: boolean
  message: string
  data: Tenant[]
}

export interface UpdateTenantRequest {
  name?: string
  status?: 'PENDING' | 'ACTIVE' | 'INACTIVE' | 'SUSPENDED'
}

export const tenantsApi = {
  /**
   * Get all tenants
   */
  async getTenants(): Promise<ApiResponse<Tenant[]>> {
    try {
      const response = await apiClient.get<Tenant[]>('/auth-service/api/v1/tenants', undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get tenants error:', error)
      throw error
    }
  },

  /**
   * Get tenant by ID
   */
  async getTenantById(tenantId: string): Promise<ApiResponse<{ success: boolean; message: string; data: Tenant }>> {
    try {
      const response = await apiClient.get<{ success: boolean; message: string; data: Tenant }>(`/auth-service/api/v1/tenants/${tenantId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get tenant by ID error:', error)
      throw error
    }
  },

  /**
   * Create a new tenant
   */
  async createTenant(tenantData: { name: string }): Promise<ApiResponse<{ success: boolean; message: string; data: Tenant }>> {
    try {
      const response = await apiClient.post<{ success: boolean; message: string; data: Tenant }>('/auth-service/api/v1/tenants', tenantData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Create tenant error:', error)
      throw error
    }
  },

  /**
   * Update tenant
   */
  async updateTenant(tenantId: string, tenantData: UpdateTenantRequest): Promise<ApiResponse<Tenant>> {
    try {
      const response = await apiClient.patch<Tenant>(`/auth-service/api/v1/tenants/${tenantId}`, tenantData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Update tenant error:', error)
      throw error
    }
  },

  /**
   * Delete tenant
   */
  async deleteTenant(tenantId: string): Promise<ApiResponse<{ success: boolean; message: string }>> {
    try {
      const response = await apiClient.delete<{ success: boolean; message: string }>(`/auth-service/api/v1/tenants/${tenantId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Delete tenant error:', error)
      throw error
    }
  }
}
